import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';

const titleHeight = '7.29vh';

export const styles = makeStyles(theme => ({
  titleContainer: {
    height: titleHeight,
    padding: '0 1.97vw',
    backgroundColor: themeColor.white,
  },
  title: {
    fontSize: vh(2.6),
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 0.25,
  },
  icon: {
    color: theme.palette.info.dark,
  },
  iconElement: {
    fontSize: vh(3.12),
    height: '100%',
  },
}));
